import React from "react";
import { convertThenFormat1 } from "../../common-data/Converts";

const ParoleInfoForm = ({ payrollData }) => {
  return (
    <>
      {/* Employee Information Card */}
      <div className="pp-approval-employee-card">
        <div className="pp-approval-employee-header">
          <div className="pp-approval-employee-avatar">
            {payrollData?.name?.charAt(0)?.toUpperCase()}
          </div>
          <div className="pp-approval-employee-info">
            <h4 className="pp-approval-employee-name">{payrollData?.name}</h4>
            <p className="pp-approval-employee-role">
              {payrollData?.account_type?.replace(/_/g, " ")}
            </p>
            <p className="pp-approval-employee-gym">{payrollData?.gym_name}</p>
          </div>
        </div>
      </div>

      {/* Salary Breakdown */}
      <div className="pp-approval-salary-card">
        <h5 className="pp-approval-card-title">Salary Breakdown</h5>
        <div className="pp-approval-salary-grid">
          <div className="pp-approval-salary-item">
            <span className="pp-approval-salary-label">Monthly Salary</span>
            <span className="pp-approval-salary-value">
              ₹{convertThenFormat1(payrollData?.monthly_salary || 0)}
            </span>
          </div>
          <div className="pp-approval-salary-item">
            <span className="pp-approval-salary-label">Gross Salary</span>
            <span className="pp-approval-salary-value">
              ₹{convertThenFormat1(payrollData?.total_basic_salary || 0)}
            </span>
          </div>
          <div className="pp-approval-salary-item">
            <span className="pp-approval-salary-label">Incentive</span>
            <span className="pp-approval-salary-value positive">
              +₹{convertThenFormat1(payrollData?.incentive || 0)}
            </span>
          </div>
        </div>
      </div>

      {/* Attendance Details */}
      <div className="pp-approval-attendance-card">
        <h5 className="pp-approval-card-title">Attendance Summary</h5>
        <div className="pp-approval-attendance-grid">
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Total Days</span>
            <span className="pp-approval-attendance-value">
              {payrollData?.total_days || 0}
            </span>
          </div>
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Present</span>
            <span className="pp-approval-attendance-value present">
              {payrollData?.total_present || 0}
            </span>
          </div>
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Absent</span>
            <span className="pp-approval-attendance-value absent">
              {payrollData?.total_absent || 0}
            </span>
          </div>
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Leave</span>
            <span className="pp-approval-attendance-value">
              {payrollData?.total_leave || 0}
            </span>
          </div>
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Half Day</span>
            <span className="pp-approval-attendance-value">
              {payrollData?.total_half_day || 0}
            </span>
          </div>
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Week Off</span>
            <span className="pp-approval-attendance-value">
              {payrollData?.total_weekoff || 0}
            </span>
          </div>
          <div className="pp-approval-attendance-item">
            <span className="pp-approval-attendance-label">Late</span>
            <span className="pp-approval-attendance-value late">
              {payrollData?.total_late || 0}
            </span>
          </div>
        </div>
      </div>

      {/* Deductions Card */}
      <div className="pp-approval-deductions-card">
        <h5 className="pp-approval-card-title">Deductions & Contributions</h5>
        <div className="pp-approval-deductions-grid">
          <div className="pp-approval-deduction-item">
            <span className="pp-approval-deduction-label">ESI Amount</span>
            <span className="pp-approval-deduction-value">
              -₹{convertThenFormat1(payrollData?.esi_amount || 0)}
            </span>
          </div>
          <div className="pp-approval-deduction-item">
            <span className="pp-approval-deduction-label">PF/TDS Amount</span>
            <span className="pp-approval-deduction-value">
              -₹{convertThenFormat1(payrollData?.pf_amount || 0)}
            </span>
          </div>
          {/* <div className="pp-approval-deduction-item">
            <span className="pp-approval-deduction-label">
              Other Deductions
            </span>
            <span className="pp-approval-deduction-value">
              -₹
              {convertThenFormat1(payrollData?.deduction || 0)}
            </span>
          </div> */}
          <div className="pp-approval-deduction-item total">
            <span className="pp-approval-deduction-label">
              Total Deductions
            </span>
            <span className="pp-approval-deduction-value">
              -₹{convertThenFormat1(payrollData?.total_deduction || 0)}
            </span>
          </div>
        </div>
      </div>

      {/* Previous Approvals (if any) */}
      {(payrollData?.user_approval_desc ||
        payrollData?.stack_holder_approval_desc) && (
        <div className="pp-approval-history-card">
          <h5 className="pp-approval-card-title">Previous Approval History</h5>
          <div className="pp-approval-history-grid">
            {payrollData?.user_approval_desc && (
              <div className="pp-approval-history-item">
                <span className="pp-approval-history-label">Staff Review:</span>
                <span className="pp-approval-history-desc">
                  {payrollData.user_approval_desc}
                </span>
              </div>
            )}
            {payrollData?.stack_holder_approval_desc && (
              <div className="pp-approval-history-item">
                <span className="pp-approval-history-label">HR Decision:</span>
                <span className="pp-approval-history-desc">
                  {payrollData.stack_holder_approval_desc}
                </span>
              </div>
            )}
          </div>
        </div>
      )}

      {/* Net Salary */}
      <div className="pp-approval-net-salary">
        <span className="pp-approval-net-label">Net Salary</span>
        <span className="pp-approval-net-value">
          ₹{convertThenFormat1(payrollData?.net_salary || 0)}
        </span>
      </div>
    </>
  );
};

export default ParoleInfoForm;
